import { useState, useEffect } from "react";
import { fetchContactData } from "../api/contact";

function useGetContactText() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await fetchContactData();
        setData(response.data.contactCollection.items[0]);
        setLoading(false);
      } catch (err) {
        setError(err);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return { data, loading, error };
}

export { useGetContactText };
